export default __webpack_public_path__ + "img/github.6c955556.svg";